<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    :footer="false"
    size="normal"
    :loading="importHandleLoading"
    :loading-text="importHandleLoadingText"
  >
    <template #header>
      <span>导入业务报告</span>
    </template>
    <template #content>
      <div class="m-t-10">
        <gj-market-select
          v-model="filter.marketId"
          placeholder="请选择店铺"
          @input="marketChange($event)"
          width="120px"  
        ></gj-market-select>
      </div>
      <div class="m-tb-20">
        <gj-upload
          :template-url="`/supply/shipment/downloadShipmentProductTemp?areCasesRequired=${areCasesRequired}`"
          container-type="shipmentProduct"
          @uploadAfter="uploadAfter"
          style="margin-bottom: 10px;"
        ></gj-upload>
      </div>
      <gj-import-alert
        :rules="[
            '下载位置1：Reports→Business Reports→Detail Page Sales and Traffic根据商品→详情页面上的销售量和访问量；',
            '下载位置2：Reports→Business Reports→Detail Page Sales and Traffic by Child Item根据商品→子商品详情页面上的销售量与访问量；',
            '导出时，请选择该报表的所有项，报告中的内容不可更改，不可删除；',
            '重复导入将自动覆盖原始数据；',
            '导入MSKU的数据系统将按照ASIN汇总展示；'
          ]"
      ></gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, uploadMixin } from "../../../../../../../minxins";
import { getSpAdCampaignStrategyList } from "../../../../../../../api/ad";
//   import {importProductInventoryInitCost} from "../../../../../../api/warehouse";

export default {
  name: "app-product-inventory-import-modal",
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {
      shopLsit: [],
      filter: {
        marketId: null
      }
    };
  },
  methods: {
    destroy() {
      this.$gjModal.$gjDestroy();
    },
    marketChange(marketId) {
      this.$emit("market-input", marketId);
      this.option.campaignLoading = true;
      this.option.campaignOption = [];
      this.filter.campaignId = null;
      this.option.groupOption = [];
      this.filter.groupId = null;
      getSpAdCampaignStrategyList({
        marketId
      })
        .then(data => {
          if (data) {
            this.option.campaignOption = data.map(e => ({
              id: e.campaignId,
              text: e.campaignName
            }));
          }
        })
        .then(() => (this.option.campaignLoading = false));
    },
       uploadAfter(attId) {
        //  这个页面的上传已经被注释
        this.importHandleLoading = true;
        // importShipmentProduct({
        //   areCasesRequired: this.areCasesRequired,
        //   attachmentId: attId,
        //   countryCode: this.countryCode,
        //   hideMskuList: this.hideMskuList,
        //   warehouseId: this.warehouseId
        // })
        //   .then((res) => {
        //     this.$gjImportHandle(res);
        //   })
        //   .complete(() => this.importHandleLoading = false);
      }
  }
};
</script>

<style scoped>
.upload-btn {
  margin: 5px 0 15px;
}
.m-tb-20 {
  margin: 20px 0px 20px 0px;
}
.m-t-10 {
  margin-top: 10px;
}
div .el-select {
  width: 175px !important;
}
</style>
